<div class="driver-success-model">
    <div class="recommendation-img">
        <img src="../../../../../assets/images/recommendation-icon.svg" alt="Recommendation" />
    </div>
    <h4>Recommendation</h4>
    <p>{{bodyText}}</p>
    <div class="btn-outer">
        <p-button label="{{buttonText}}" (onClick)="cancelDialog()" />
    </div>
</div>